'use strict';

(function () {
    angular
        .module('tracking')
        .component('crewScheduleSlideInComponent', {
            templateUrl: 'tracking/components/crew-schedule-slidein-component.tpl.html',
            controller: function ($timeout, $scope, applicationConstants) {
                var vm = this;

                vm.model = {
                    isCrewScheduleActive : false
                };

                vm.onCrewScheduleClick = function () {
                    vm.model.isCrewScheduleActive = !vm.model.isCrewScheduleActive;
                };
            },
            bindings: {}
        });
})();
